import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getArtistStatementWriters = (page, pageSize = 10, artistId, cancelToken = null) => {
  return axios.get(URL_PREFIX + '/artist-statement-writers/', {
    params: {
      artist: artistId,
      page: page,
      page_size: pageSize
    },
    cancelToken: cancelToken?.token
  })
}

export const getArtistStatementWriter = (id) => {
  return axios.get(URL_PREFIX + '/artist-statement-writers/' + id + '/')
}

export const postArtistStatementWriters = (params) => {
  return axios.post(URL_PREFIX + '/artist-statement-writers/', params)
}

export const patchArtistStatementWriters = (id, params) => {
  return axios.patch(URL_PREFIX + '/artist-statement-writers/' + id + '/', params)
}

export const deleteArtistStatementWriters = (id) => {
  return axios.delete(URL_PREFIX + '/artist-statement-writers/' + id + '/')
}
